import Vuex from 'vuex'
import * as types from '../mutation-types'
import { API } from '../../api'
import { CONTRAST_DATA_MANAGER, FATE_DATA_MANAGER } from '../../data'
import FateFortuneStore from '../plugins/fatefortune'
export default {
    namespaced: true,
    modules: {},
    state: {
        showContrastCreatePanel: false,
        gotContrastList: false,
        contrastFromPage: '',
        contrastList: [],
        contrastSearchList: [],
        contrastData: {},
        contrastDetailDataList: [],
        contrastFFStoreList: [],
        contrastFFActiveList: [],
        contrastTimeInteracted: false,
        contrastShowFortune: true,
        contrastShowItemDelete: false,
        contrastShowCommentContent: false,
        contrastShowCommentEdit: false,
        contrastCommentContent: '',
        contrastChoosedType: 3, //默认对比合婚
        contrastChoosedTypeText: '对比合婚',
        contrastChoosedBaziList: [],
    },
    mutations: {
        [types.CONTRAST_UPDATE_TIME_INTERACTIVE_LIST](state, params) {
            let detailDataList = state.contrastDetailDataList;
            let actList = [];
            detailDataList.forEach((el, index) => {
                if(index != params.itemIndex) {
                    let actFF = CONTRAST_DATA_MANAGER.getContrastTimeInteractivedFortune(params.columnData.year, el, index);
                    if(actFF != null) {
                        actList.push(Object.assign({ffIndex: index}, actFF));
                    }
                }
            });
            state.contrastFFActiveList = actList;
            actList.forEach(el => {
                let ffStore = state.contrastFFStoreList[el.ffIndex];
                ffStore.dispatch('showContrastItemLiuYue', el)
            });
        },
        [types.CONTRAST_UPDATE_TIME_INTERACTIVE_DELETE_LIST](state, params) {
            let ffStoreList = [].concat(state.contrastFFStoreList);
            ffStoreList.forEach((ffStore, index) => {
                if(index != params.itemIndex) {
                    if(params.columnData.type == 'dayun') {
                        ffStore.dispatch('showContrastItemFortune');
                    }else if(params.columnData.type == 'liunian') {
                        ffStore.dispatch('showContrastItemLiuNian');
                    }
                }
            })
        }
    },
    actions: {
        initContrastList({state, commit}, params) {
            if(state.gotContrastList) {
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                return;
            }
            API.getContrastList({
                id: 0
            }, function(data) {
                console.log('获取对比记录列表成功:::::::', data)
                state.gotContrastList = true;
                state.contrastList = CONTRAST_DATA_MANAGER.getContrastListByList(data);
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        getSearchContrastList({ state }, text) {
            let tempList = [].concat(state.contrastList);
                tempList = tempList.filter(data => data.f_title.toLowerCase().indexOf(text.toLowerCase()) !== -1);
            state.contrastSearchList = [].concat(tempList);
            console.log('getSearchContrastList-----', state.contrastSearchList);
        },
        initContrast({state}, params) {
            let contrastData = params.contrastData;            
            let bzinfo = contrastData.bzinfo;
            console.log('initContrast-----', bzinfo, contrastData.bzid);
            
            let detailList = [], ffStoreList = [];
            bzinfo.forEach(el => {
                if(contrastData.bzid.indexOf(el.id) >= 0) {
                    var detailData = FATE_DATA_MANAGER.getDetailFateDataByData(el, 'detail');
                    detailList.push(detailData);
                    // 直接实例化
                    let ffStore = new Vuex.Store(FateFortuneStore);
                        if(contrastData.bzid.split(',').length <= 2) {
                            ffStore.state.showTable = 10;
                        }
                        ffStore.state.fromParent = 'contrast';
                        ffStore.dispatch('initDetailFateFortune', detailData);
                    ffStoreList.push(ffStore);
                }
            });

            state.contrastData = contrastData;
            state.contrastCommentContent = contrastData.f_content;
            state.contrastDetailDataList = detailList;
            state.contrastFFStoreList = ffStoreList;
            if(params && params.cb && typeof(params.cb) == 'function') {
                params.cb();
            }
        },
        triggerContrastFortuneItemClick({state, commit}, params) {
            let itemIndex = params.itemIndex;
            let ffStore = state.contrastFFStoreList[itemIndex];
                ffStore.dispatch('addDetailFateSide', params.columnData);

            console.log('triggerContrastFortuneItemClick------', params.columnData);
            switch(params.columnData.type) {
                case 'dayun':
                    ffStore.dispatch('showDetailLiuNian', params.columnData);
                    break;
                case 'liunian':
                    ffStore.dispatch('showDetailLiuYue', params.columnData.year);
                    if(state.contrastTimeInteracted) {
                        commit(types.CONTRAST_UPDATE_TIME_INTERACTIVE_LIST, params);
                    }
                    break;
                case 'liuyue':
                    ffStore.dispatch('showDetailLiuRi', params.columnData.time);
                    break;
                case 'liuri':
                    ffStore.dispatch('showDetailLiuShi', params.columnData.g);
                    break;
                default:
                    break;
            }
        },
        triggerContrastFateSideItemClose({state, commit}, params) {
            let itemIndex = params.itemIndex;
            let ffStore = state.contrastFFStoreList[itemIndex];
                ffStore.dispatch('deleteDetailFateSide', params.columnData);
            if(state.contrastTimeInteracted) {
                if(params.columnData.type == 'dayun' || params.columnData.type == 'liunian') {
                    commit(types.CONTRAST_UPDATE_TIME_INTERACTIVE_DELETE_LIST, params);
                }
            }
        },
        addContrast({dispatch, state}, params) {
            let cType = state.contrastChoosedType,
                cTypeText = state.contrastChoosedTypeText;
            let cBazi = params.choosedList.map(el => el.id);
            let cTitle = params.choosedList.map((el, index) => index <= 1 ? (el.name ? el.name : (el.f_name ? el.f_name : '')) : '');
                cTitle = cTitle.filter(el => el != '');
            API.addContrast({
                bzid: cBazi.join(','),
                f_title: cTypeText+':'+cTitle.join(',')+'等',
                f_type: cType
            }, (data)=> {
                console.log('添加对比成功------', data);
                // 更新列表
                state.gotContrastList = false;
                dispatch('initContrastList', {
                    cb: ()=> {
                        // 处理跳转
                        let cData = state.contrastList.find(el => el.id == data.id);
                        if(!cData) { return; }
                        dispatch('initContrast', {
                            contrastData: cData,
                            cb: ()=> {
                                if(params && params.cb && typeof(params.cb) == 'function') {
                                    params.cb(cData);
                                }
                            }
                        });

                    }
                });
            })
        },
        updateContrast({dispatch, state}, params) {
            let newParams = {};
            let contrastData = state.contrastData;
            console.log('updateContrast-----', params, contrastData)
            switch(params.type) {
                case 'bzid_add':
                    newParams = {
                        id: contrastData.id,
                        bzid: contrastData.bzid+','+params.value.join(',')
                    }
                    break;
                case 'bzid_del':
                    let bzidArr = contrastData.bzid.split(',');
                    bzidArr.splice(params.value, 1);
                    newParams = {
                        id: contrastData.id,
                        bzid: bzidArr.join(',')
                    }
                    break;
                case 'title':
                    newParams = {};
                    break;
                case 'content':
                    newParams = {
                        id: contrastData.id,
                        f_content: params.value
                    };
                    break;
                default:
                    break;
            }
            console.log('update-------', newParams)
            API.updateContrast(newParams, (data)=> {
                console.log('更新对比成功-------', data)
                if(params.type == 'bzid_add') {
                    // 更新列表
                    state.gotContrastList = false;
                    dispatch('initContrastList', {
                        cb: ()=> {
                            // 处理跳转
                            let cData = state.contrastList.find(el => el.id == contrastData.id);
                            if(!cData) { return; }
                            dispatch('initContrast', {
                                contrastData: cData,
                                cb: ()=> {
                                    if(params && params.cb && typeof(params.cb) == 'function') {
                                        params.cb();
                                    }
                                }
                            });
    
                        }
                    });
                }else {
                    // 更新详情数据
                    let newContrastData = Object.assign(state.contrastData, newParams);
                    state.contrastData = newContrastData;
                    // 更新列表数据
                    let cIndex = state.contrastData.cIndex;
                    state.contrastList[cIndex] = newContrastData;
                    // 更新其他状态
                    switch(params.type) {
                        case "bzid_del":
                            state.contrastFFStoreList.splice(params.value, 1);
                            // 删除到只剩两个了
                            if(state.contrastFFStoreList.length == 2) {
                                dispatch('initContrast', {
                                    contrastData: newContrastData
                                });
                            }
                            break;
                        case "content":
                            state.contrastShowCommentEdit = false;
                            break;
                        default:
                            break;
                    }
                }
            })
        },
        deleteContrast({state}, params) {
            API.deleteContrast({
                id: params.delId
            }, ()=> {
                // 更新列表
                state.contrastList = state.contrastList.filter(el => el.id != params.delId);
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        resetContrastDefaultData({state}) {
            state.contrastChoosedType = 3;
            state.contrastChoosedTypeText = '对比合婚';
        },
        resetContrastData({state}) {
            state.contrastData = {};
            state.contrastDetailDataList = [];
            state.contrastFFStoreList = [];
            state.contrastFFActiveList = [];
            state.contrastTimeInteracted = false;
            state.contrastShowFortune = true;
            state.contrastShowItemDelete = false;
            state.contrastShowCommentContent = false;
            state.contrastShowCommentEdit = false;
            state.contrastCommentContent = '';
            state.contrastChoosedType = 3;
            state.contrastChoosedTypeText = '对比合婚';
            state.contrastChoosedBaziList = [];
        }
    }
}
